import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeLabelHtml } from '../utils/sanitizeLabelHtml';

const MMColumnItem = ({ headerLabel, children }) => {
	return (
		<>
			<h4>{sanitizeLabelHtml(headerLabel)}</h4>
			{children}
		</>
	);
};

MMColumnItem.propTypes = {
	headerLabel: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired
};

export default MMColumnItem;
